/**
 * @file LandingPage.tsx
 * @description
 * -----------------------------------------------------
 * Archivo que contiene la landing page del sitio
 * -----------------------------------------------------
 * @version 1.0.0a
 * @created 2025-11-06
 * @author Correcta
 * @author Cristina Comesaña
 * @copyright © Correcta
 * @license Private
 * */

"use client";
import ImageComponent from "@/components/ui/ImageComponent";
import { useTranslations } from "next-intl";
import { TrendingUp } from "lucide-react";

export default function LandingPage() {
  const landing = useTranslations("Landing");

  return (
    <>
      <section className={"landing"}>
        <section className="landing__head">
          <h1 className="landing__head__title">{landing("titlePart1")}</h1>
        </section>

        <section className="landing__features">
          <article className="landing__features__card">
            <section className="landing__features__card__header">
              <TrendingUp className="landing__features__card__icon" size={80} />
              <h2 className="landing__features__card__title">
                {landing("featureTitle1")}
              </h2>
            </section>
            <p className="landing__features__card__text">
              {landing("featureText1")}
            </p>
          </article>

          <article className="landing__features__card">
            <section className="landing__features__card__header">
              <TrendingUp className="landing__features__card__icon" size={80} />
              <h2 className="landing__features__card__title">
                {landing("featureTitle2")}
              </h2>
            </section>
            <p className="landing__features__card__text">
              {landing("featureText2")}
            </p>
          </article>

          <article className="landing__features__card">
            <section className="landing__features__card__header">
              <TrendingUp className="landing__features__card__icon" size={80} />
              <h2 className="landing__features__card__title">
                {landing("featureTitle3")}
              </h2>
            </section>
            <p className="landing__features__card__text">
              {landing("featureText3")}
            </p>
          </article>
        </section>

        <section className="landing__content">
          <article className="landing__content__wrapper">
            <ImageComponent
              src="/assets/svg/image-landing.svg"
              alt={"landingCounterAlt"}
              zoomable={false}
              className="landing__content__image"
            />
            <section className="landing__content__text-box">
              <h3 className="landing__content__text-box__title">
                {landing("contentBoxTitle")}
              </h3>
              <p className="landing__content__text-box__text">
                {landing("contentBoxText1")}
              </p>
              <p className="landing__content__text-box__text">
                {landing("contentBoxText2")}
              </p>
            </section>
          </article>
        </section>

        <section className={"landing__statistics"}>
          <section className={"landing__statistics__content"}>
            <h2 className="landing__statistics__content__title--tertiary">
              {landing("statisticsTitlePart1")}
            </h2>
            <section className={"landing__statistics__content--cards "}>
              {/* CARD 1 */}
              <article className="landing__statistics__content--card landing__statistics__content--card1">
                <ImageComponent
                  src="/assets/svg/image-landing-gallery-1.svg"
                  alt={"landingCounterAlt1"}
                  zoomable={false}
                />
              </article>

              {/* CARD 2 */}
              <article className="landing__statistics__content--card landing__statistics__content--card2">
                <ImageComponent
                  src="/assets/svg/image-landing-gallery-2.svg"
                  alt={"landingCounterAlt2"}
                  zoomable={false}
                />
              </article>

              {/* CARD 3 */}
              <article className="landing__statistics__content--card landing__statistics__content--card3">
                <ImageComponent
                  src="/assets/svg/image-landing-gallery-3.svg"
                  alt={"landingCounterAlt3"}
                  zoomable={false}
                />
              </article>

              {/* CARD 4 */}
              <article className="landing__statistics__content--card landing__statistics__content--card4">
                <ImageComponent
                  src="/assets/svg/image-landing-gallery-4.svg"
                  alt={"landingCounterAlt4"}
                  zoomable={false}
                />
              </article>
            </section>
          </section>
        </section>
      </section>
    </>
  );
}
